import React from 'react';
import PropTypes from 'prop-types';

const BrandMail = props => {

    const { brand, urlBrand, urlPortadaEspeciales } = props;

    return (
        <article className="mx-3 py-2 brand-firm text-center">
            <a className="d-block text-black mail-to-form text-black" href={urlPortadaEspeciales} target="_blank" rel="noreferrer">Especiales {brand}</a>
            <a className="d-block text-black mail-to text-black" href={urlBrand} target="_blank" rel="noreferrer">{urlBrand.replace('https://','')}</a>                                    
        </article>
    )
}

export default BrandMail;

BrandMail.propTypes = {
    brand: PropTypes.string.isRequired,
    urlBrand: PropTypes.string.isRequired,
    urlPortadaEspeciales: PropTypes.string.isRequired
}

